import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { analyticsConfigured, getConsent, loadAnalytics, CONSENT_KEY } from "../lib/analytics";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!analyticsConfigured()) return; // nothing to consent to yet
    const stored = getConsent();
    if (stored === "accepted") loadAnalytics();
    else if (!stored) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    setVisible(false);
    if (value === "accepted") loadAnalytics();
  };

  if (!visible) return null;
  return (
    <div className="cookiebar" data-testid="cookie-consent">
      We use cookies to understand how golfers find and use this site. No tracking runs unless you say yes.{" "}
      <Link to="/cookies" style={{ color: "var(--gold-hi)" }}>Cookie policy</Link>
      <div className="row">
        <button onClick={() => decide("declined")} data-testid="cookie-decline">Decline</button>
        <button className="accept" onClick={() => decide("accepted")} data-testid="cookie-accept">Accept</button>
      </div>
    </div>
  );
};
